import { render, staticRenderFns } from "./teach.vue?vue&type=template&id=ee27aa86&scoped=true&"
import script from "./teach.vue?vue&type=script&lang=js&"
export * from "./teach.vue?vue&type=script&lang=js&"
import style0 from "./teach.vue?vue&type=style&index=0&id=ee27aa86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee27aa86",
  null
  
)

export default component.exports